import { apiPut } from "../ApiMethod";
import { setFirmwareData } from "../../mappers";

export const updateAppRelease = async (data, id) => {
  const response = await apiPut("_appRelease", id, data);
  return { ...response, data: setFirmwareData(response.data) };
};
